<ng-container *ngIf="content$ | async as operation" [xOperation]="operation">
  <div *xOperationResult class="channel-content border-top-color">
    <ng-container *ngFor="let section of operation.data?.channelFooter">
      <ng-template [xDynamicComponent]="section"></ng-template>
    </ng-container>
  </div>
</ng-container>
